const insights = [
  {
    tag: "基礎設施",
    title: "Cyberport AISC 超算中心達 3000 PFLOPS",
    desc: "AI Supercomputing Centre 利用率已超過 80%，香港正快速成為亞太 AI 算力重要節點，為本地初創提供關鍵計算資源。",
    icon: "ri-server-line",
  },
  {
    tag: "政府政策",
    title: "$30億 AI Subsidy Scheme 批准約 30 個研發項目",
    desc: "香港政府 $30億 AI 資助計劃持續推進，已批准多個本地 AI 研發項目，更多機會仍在陸續開放申請。",
    icon: "ri-government-line",
  },
  {
    tag: "金融科技",
    title: "GenA.I. Sandbox 第二批與 HKMA 合作推進",
    desc: "GenA.I. Sandbox 第二批正與 HKMA 合作推動「AI vs AI」在金融業的應用，香港 FinTech x AI 融合進入新階段。",
    icon: "ri-bank-line",
  },
  {
    tag: "新興趨勢",
    title: "Agentic AI 在本地落地機會快速增加",
    desc: "多智能體系統（Agentic AI）正在香港企業中快速找到落地場景，從客服自動化到流程智能，機會遍地開花。",
    icon: "ri-robot-2-line",
  },
];

export default function InsightsSection() {
  return (
    <section id="insights" className="py-24 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <div>
            <p className="text-amber-600 text-sm font-semibold tracking-widest uppercase mb-3">2026 Observations</p>
            <h2 className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight" style={{ fontFamily: "'Noto Serif TC', serif" }}>
              我在香港AI生態的
              <br className="hidden md:block" />
              最新觀察（2026）
            </h2>
          </div>
          <p className="text-stone-500 text-sm max-w-xs leading-relaxed">
            我會持續在 LinkedIn 分享更多第一手資訊，歡迎關注。
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {insights.map((item, i) => (
            <div
              key={i}
              className="bg-white border border-stone-200 rounded-xl p-7 flex gap-5 hover:-translate-y-1 transition-transform duration-300 cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-amber-50 text-amber-600 shrink-0">
                <i className={`${item.icon} text-xl`} />
              </div>
              <div>
                <span className="inline-block bg-amber-100 text-amber-700 text-xs font-semibold px-2.5 py-0.5 rounded-full mb-2">
                  {item.tag}
                </span>
                <h3 className="text-stone-900 font-bold text-base mb-2 leading-snug">{item.title}</h3>
                <p className="text-stone-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* LinkedIn CTA */}
        <div className="mt-10 text-center">
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 border border-stone-200 bg-white text-stone-700 hover:border-amber-500 hover:text-amber-600 text-sm font-semibold px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-linkedin-fill text-base" />
            在 LinkedIn 關注我的最新動態
          </a>
        </div>
      </div>
    </section>
  );
}
